import React, { useState, useRef } from "react";
import secureAxios from "../../utils/secureAxios";
import { useAuth } from "../../contexts/AuthContext";
import { getApiBaseURL } from "../../utils/api";

const CreateTicketForm = () => {
  const { user } = useAuth();
  const [formData, setFormData] = useState({
    subject: "",
    description: "",
    priority: "normal",
    file: null,
  });
  const [message, setMessage] = useState("");
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, file: e.target.files[0] }));
  };

  const handlePaste = (e) => {
    const items = e.clipboardData.items;
    for (const item of items) {
      if (item.type.indexOf("image") !== -1) {
        const blob = item.getAsFile();
        setFormData((prev) => ({ ...prev, file: blob }));
        if (fileInputRef.current) fileInputRef.current.value = null;
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const apiBase = getApiBaseURL();
    // const apiBase = process.env.REACT_APP_API_BASE || "";
    const data = new FormData();
    data.append("subject", formData.subject);
    data.append("description", formData.description);
    data.append("priority", formData.priority);
    data.append("user_id", user.user_id);
    data.append("tenant_id", user.tenant_id);
    if (formData.file) {
      data.append("attachment", formData.file);
    }

    try {
      await secureAxios.post(`${apiBase}/api/tickets`, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage("✅ Ticket submitted successfully.");
      setFormData({
        subject: "",
        description: "",
        priority: "normal",
        file: null,
      });
    } catch (err) {
      console.error("❌ Error creating ticket:", err);
      setMessage("❌ Failed to submit ticket.");
    }
  };

  return (
    <form onSubmit={handleSubmit} onPaste={handlePaste} className="card p-3">
      <h5>Create Ticket</h5>
      {message && <p className="fw-bold">{message}</p>}
      <div className="mb-3">
        <label className="form-label">Subject</label>
        <input
          name="subject"
          className="form-control"
          value={formData.subject}
          onChange={handleChange}
          required
        />
      </div>
      <div className="mb-3">
        <label className="form-label">
          Description (paste screenshots here)
        </label>
        <textarea
          name="description"
          className="form-control"
          value={formData.description}
          onChange={handleChange}
          rows={4}
        />
      </div>
      <div className="mb-3">
        <label className="form-label">Priority</label>
        <select
          name="priority"
          className="form-select"
          value={formData.priority}
          onChange={handleChange}
        >
          <option value="low">Low</option>
          <option value="normal">Normal</option>
          <option value="high">High</option>
          <option value="urgent">Urgent</option>
        </select>
      </div>
      <div className="mb-3">
        <label className="form-label">Attachment</label>
        <input
          type="file"
          className="form-control"
          onChange={handleFileChange}
          ref={fileInputRef}
        />
        {formData.file && (
          <p className="mt-1 text-muted small">
            Attached: {formData.file.name || "Screenshot image"}
          </p>
        )}
      </div>
      <button type="submit" className="btn btn-primary">
        Submit Ticket
      </button>
    </form>
  );
};

export default CreateTicketForm;
